<script>
import { difference } from 'lodash';
import { createNamespacedHelpers } from 'vuex';
const corpMapState = createNamespacedHelpers('corp').mapState;

export default {
    props: {
        workingDays: {
            type: Array,
            required: true,
        },
        activityData: {
            type: Object,
            required: false,
        },
        workingHours: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localizedTexts: {
                date: this.$l10n.__('Date'),
            },
            MINUTES_INTERVAL: 5,
        };
    },
    computed: {
        ...corpMapState(['hourformat', 'uiLang', 'timeformat']),
        formatDateDisplayed() {
            return this.timeformat === 'dmy' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
        },
        disabledWeekDays() {
            return difference([0, 1, 2, 3, 4, 5, 6], this.workingDays);
        },
        momentTimeFormat() {
            return this.hourformat === '12' ? 'hh:mm A' : 'HH:mm';
        },
        workingTimeEnd() {
            return moment(this.workingHours.end_time, this.momentTimeFormat).format(
                this.momentTimeFormat,
            );
        },
        workingTimeStart() {
            return moment(this.workingHours.start_time, this.momentTimeFormat).format(
                this.momentTimeFormat,
            );
        },
    },
    methods: {
        formatTimeInput(time) {
            const rest = time.format('mm') % this.MINUTES_INTERVAL;
            if (rest < 8) {
                time.subtract(rest, 'minutes').calendar();
            } else {
                time.add(this.MINUTES_INTERVAL - rest, 'minutes').calendar();
            }
            return time.format('HH:mm');
        },
        getTime(dueDate) {
            const formattedDueTime = this.getFormattedTime(moment(dueDate));
            return this.getTimeBasedOnWorkingHours(formattedDueTime);
        },
        getCurrentTime() {
            const currentTime = this.getFormattedTime(moment());
            return this.getTimeBasedOnWorkingHours(currentTime);
        },
        getFormattedTime(momentInstance) {
            return moment().set({
                hour: momentInstance.hour(),
                minute: momentInstance.minute(),
            });
        },
        getTimeBasedOnWorkingHours(formattedTime) {
            const startTime = moment(this.workingHours.start_time, 'HH:mm');
            const endTime = moment(this.workingHours.end_time, 'HH:mm');

            if (formattedTime.isBefore(startTime)) {
                return startTime.format('HH:mm');
            } else if (formattedTime.isAfter(endTime)) {
                return endTime.format('HH:mm');
            } else {
                return this.formatTimeInput(formattedTime);
            }
        },
        getNextWorkingDay() {
            const date = moment().add(1, 'day');
            let counter = 0; // To avoid infinite loop if no working days are selected
            while (!this.workingDays.includes(date.day()) && counter < 7) {
                date.add(1, 'day');
                counter++;
            }
            return date.format('YYYY-MM-DD');
        },
    },
};
</script>
